// extracted by mini-css-extract-plugin
export default {"wrap":"test-results__wrap__qm","loading":"test-results__loading__yl","button":"test-results__button__g7","hr":"test-results__hr__Ho"};